import { useEffect, useState } from 'react';
import { listJobTrips, type JobTrip } from '../trips.api';

export type JobTripsState = { status: 'loading' } | { status: 'ready'; trips: JobTrip[] } | { status: 'error' };

/** A job has a handful of trips, so the panel loads them whole rather than paging. */
export function useJobTrips(jobId: string): JobTripsState {
  const [loaded, setLoaded] = useState<{ jobId: string; state: JobTripsState } | null>(null);

  useEffect(() => {
    let cancelled = false;
    listJobTrips(jobId)
      .then(({ trips }) => {
        if (!cancelled) setLoaded({ jobId, state: { status: 'ready', trips } });
      })
      .catch(() => {
        if (!cancelled) setLoaded({ jobId, state: { status: 'error' } });
      });
    return () => {
      cancelled = true;
    };
  }, [jobId]);

  return loaded?.jobId === jobId ? loaded.state : { status: 'loading' };
}
